module.exports = __webpack_public_path__ + "img/link.3ddcc72e.svg";